/**
 * A LICITAÇÃO ESTÁ SUSPENSA? E QUEM DISSE? (08/10/2026)
 *
 * Na lista de propostas o item 14713 (SAMAE Blumenau, ComprasBR, suspenso pelo órgão em 06/10 16:16) saía com
 * DOIS selos "Suspensa", um deles dizendo no title "PNCP suspendeu a sessão" — num item que o PNCP não suspendeu.
 * A tela afirmava com confiança uma origem que não mediu. E a contagem "📄 6d" seguia correndo para um prazo
 * que o órgão tinha suspendido.
 *
 * Duas fontes, que a tela agora distingue:
 *  - `portal`: o quadro do portal (`situacaoCompra`) diz que o órgão bloqueou: evento pendente, ou aviso de
 *    suspensão com inclusão bloqueada. Tem motivo e, quase sempre, data (`ultimoAviso.dataHoraInclusao`).
 *  - `pncp`: só o status do item diz suspensa (vem da sincronização do PNCP). Sem motivo nem data no HUB.
 *
 * Medido em 08/10/2026, 228 propostas: 2 com item suspenso, 14713 (ComprasBR, fonte portal) e 3325 (PCP, fonte
 * PNCP, sem `situacaoCompra`). Revogação e anulação NÃO são suspensão e ficam de fora.
 */

export interface Suspensao {
  fonte: 'portal' | 'pncp';
  /** Quando o órgão suspendeu (instante do aviso), se o portal disse. */
  desde: string | null;
  motivo: string | null;
  /** A previsão de reabertura publicada no aviso (dd/mm/aaaa), se houver. */
  previsaoReabertura: string | null;
}

export function suspensaoDaLicitacao(item: any): Suspensao | null {
  if (!item) return null;
  const sc = item.situacaoCompra;
  const aviso = sc?.ultimoAviso || null;
  const msg = String(aviso?.mensagem || '').trim();
  const revogacao = /revogad|anulad/i.test(msg);
  const bloqueioDoPortal =
    !!sc && !revogacao && (sc.eventoPendente === true || (sc.permitirInclusao === false && /suspen/i.test(msg)));
  if (bloqueioDoPortal) {
    return {
      fonte: 'portal',
      desde: aviso?.dataHoraInclusao || null,
      motivo: msg || null,
      previsaoReabertura: aviso?.previsaoReabertura || null,
    };
  }
  if (item.status === 'suspensa') return { fonte: 'pncp', desde: null, motivo: null, previsaoReabertura: null };
  return null;
}
